var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      { staticClass: "e-form-row", attrs: { id: "_form_field_request" } },
      [
        _c("div", { staticClass: "e-input-label m-full" }, [
          _c("span", { staticClass: "e-input-mark" }, [_vm._v("任意")]),
          _vm._v(" "),
          _c("span", { staticClass: "e-input-label" }, [
            _vm._v("ご要望をお伺いします（複数選択可）")
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "e-input-field" }, [
      _c(
        "div",
        { staticClass: "e-field-grid" },
        _vm._l(_vm.requestOptions, function(row) {
          return _c(
            "div",
            { key: row.ordered, staticClass: "e-field-grid-col m-sp-full" },
            [
              _c(
                "label",
                {
                  staticClass:
                    "c-input-field-checkbox m-inline m-required m-sp-block"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.store.requests,
                        expression: "store.requests"
                      }
                    ],
                    staticClass: "e-input",
                    attrs: { type: "checkbox", name: "requests[]" },
                    domProps: {
                      value: row.label,
                      checked: Array.isArray(_vm.store.requests)
                        ? _vm._i(_vm.store.requests, row.label) > -1
                        : _vm.store.requests
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.store.requests,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = row.label,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.store, "requests", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.store,
                                "requests",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.store, "requests", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "e-label" }, [
                    _vm._v(_vm._s(row.label))
                  ])
                ]
              )
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }